import { FleekError } from './FleekError';

type ProjectDomainsLimitExceededErrorOptions = Record<string, never>;

export class ProjectDomainsLimitExceededError extends FleekError<ProjectDomainsLimitExceededErrorOptions> {
  public name = 'ProjectDomainsLimitExceededError';

  toString = () => `Your project is growing! You've reached the maximum number of domains for this project. Upgrade your plan at https://fleek.xyz/pricing to add more domains. Need assistance? Our Support team is ready to help.`
}
